import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface NgLetContext<T> {
  ngLet: T;
}

@Directive({
  selector: '[ngLet]',
})
export class NgLetDirective<T> {
  private context: NgLetContext<T> = { ngLet: null };

  constructor(
    viewContainer: ViewContainerRef,
    templateRef: TemplateRef<NgLetContext<T>>
  ) {
    viewContainer.createEmbeddedView(templateRef, this.context);
  }

  @Input({ required: true })
  set ngLet(value: T) {
    this.context.ngLet = value;
  }
}
